import { attachVideoTracking, pauseVideoTracking } from './youtube_video_tracking';

$(function(){
  function closeModalInstantly($modal) {
    var $animated = $modal.find('.alpha-background, .modal-inner-content');
    $animated.css('transition', 'none');
    $modal.removeClass('active');
    if ($animated.length) {
      $animated[0].offsetHeight;
    }
    $animated.css('transition', '');
  }

  // トリガー直下のテキストノードだけ拾う(末尾の span.arrow を除くため)。
  function triggerAreaName($trigger) {
    return $trigger.contents().filter(function() {
      return this.nodeType === 3;
    }).text().trim();
  }

  //open area modal
  $('.area-modal-open').on('click', function() {
    var targetList = $(this).attr('href');
    var $target = $(targetList);
    $('#areaModalBox .modal-header__area-name').text(triggerAreaName($(this)));
    $('#areaModalBox').addClass('active');
    $('#areaModalBox .map-box-list-item').removeClass('active');
    $target.addClass('active');
    return false;
  });
  //close area modal
  $('.close-area-modal').on('click', function() {
    closeModalInstantly($('#areaModalBox'));
    $('#areaModalBox .map-box-list-item').removeClass('active');
    return false;
  });

  //open modal content
  $('.modal-open').on('click',function() {
    var targetModalItem = $(this).attr('href');
    var target = $(targetModalItem == "#" || targetModalItem == "" ? 'html' : targetModalItem);
    $('#modalBox').addClass('active');
    // Ensure only the clicked modal panel is active
    $('.modal-inner-content *').removeClass('active');
    $('.movie-modal-item').removeClass('active');
    target.addClass('active');
    // Lazy load and autoplay only clicked movie iframe
    var $iframe = target.find('iframe[data-src]');
    if ($iframe.length) {
      var iframe = $iframe[0];
      // 初回のみ data-src から src を注入（遅延ロード）。再オープン時は src を保持したまま使い回す。
      if (!iframe.getAttribute('src')) {
        var baseSrc = iframe.getAttribute('data-src');
        var sep = baseSrc.indexOf('?') === -1 ? '?' : '&';
        iframe.setAttribute('src', baseSrc + sep + 'autoplay=1');
      }
      // GA4 再生計測を有効化（IFrame API でプレーヤー化し再生を計測）
      attachVideoTracking(iframe);
    }
    return false;
  });
  //close modal
  $('.close-modal').on('click',function(){
    // Stop any playing YouTube videos inside modal
    $('#modalBox iframe').each(function() {
      // 計測プレーヤーがあれば pause で停止（破棄しない）。無ければ src クリアで停止（フォールバック）。
      var needsSrcFallback = pauseVideoTracking(this);
      if (needsSrcFallback && this.getAttribute('src')) {
        this.setAttribute('src', '');
      }
    });
    closeModalInstantly($('#modalBox'));
    $('.modal-inner-content *').removeClass('active');
    return false;
  });
});
